<template>
  <div class="w-100 modal-h-80">
    <div class="row no-gutters">
      <div :key="slider_key" class="col-lg-6 d-none d-lg-block">
        <ProductSliderDetail :data="data" height_size="modal-h-80"></ProductSliderDetail>
      </div>
      <div class="col-lg-6 col-md-12">
        <div class="w-100 modal-h-80">
          <div class="w-100 position-relative p-4 border-b-form">
            <p class="mb-0 w-80 text-truncate" :class="window_width >= 576 ? 'heading-6' : 'body-1-2'">{{ data.name }}</p>
            <p class="mb-0 body-3-3-2 text-green">{{ data.category.name }}</p>
            <div class="position-absolute cursor-pointer" @click="close()" style="right: 25px;top:28px;">
              <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" y="0.5" width="37" height="37" rx="12.5" fill="white" />
                <path
                  d="M25.8 13.21L24.39 11.8L18.8 17.39L13.21 11.8L11.8 13.21L17.39 18.8L11.8 24.39L13.21 25.8L18.8 20.21L24.39 25.8L25.8 24.39L20.21 18.8L25.8 13.21Z"
                  fill="#222222" />
                <rect x="0.5" y="0.5" width="37" height="37" rx="12.5" stroke="#E6E8EC" />
              </svg>
            </div>
          </div>
          <div class="w-100 d-block d-lg-none" :key="slider_key">
            <ProductSliderDetail :data="data" height_size="h-200px"></ProductSliderDetail>
          </div>
          <div class="w-100 p-4 overflow-y-auto heigh-detail-content">
            <div class="w-100 mb-4">
              <p class="mb-2 body-2-4" v-if="data.duration_type != 'NO_SHOW' && duration != ''">Duration: {{ duration }}</p>
              <p class="mb-0 body-2-2">{{ data.description }}</p>
            </div>
            <div class="w-100 mb-4 p-3 border-form radius-6" v-if="data.policy != null">
              <p class="mb-2 body-2-4">{{ data.policy.name }}</p>
              <p class="mb-0 body-3 html-desc" v-html="data.policy.description"></p>
            </div>
            <div class="w-100" id="detail-form">
              <p class="body-1-4 mb-2">Select date & person</p>
              <div class="row slim-grid-row mb-3" id="filter-container">

                <!-- GUEST -->
                <div class="col-xl-4 col-sm-6 col-12 mb-3 mb-sm-0" id="guest-filter-container">
                  <button @click="guestToggleDetail()" id="guest-filter"
                    class="w-100 border-form radius-6 no-ws px-3 py-16px position-relative text-left bg-white">
                    <div class="d-inline-block align-middle mr-2">
                      <svg class="lh-1" width="23" height="16" viewBox="0 0 23 16" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_508_50)">
                          <path
                            d="M5.67617 7.96519C7.11451 7.96519 8.36733 6.66604 8.36733 4.98791C8.36733 3.31754 7.10679 2.0957 5.67617 2.0957C4.2378 2.0957 2.97728 3.34848 2.97728 5.00338C2.97728 6.66604 4.23006 7.96519 5.67617 7.96519ZM1.36104 14.9483H9.97584C10.958 14.9483 11.3369 14.5616 11.3369 13.8579C11.3369 11.7235 9.15611 9.14839 5.66844 9.14839C2.18076 9.14839 0 11.7235 0 13.8579C0 14.5616 0.38666 14.9483 1.36104 14.9483Z"
                            fill="black" fill-opacity="0.85" />
                          <path
                            d="M9.71293 16H19.4335C21.4673 16 22.1324 15.0179 22.1324 13.9198C22.1324 11.3214 19.1551 8.11987 14.5693 8.11987C9.99128 8.11987 7.01401 11.3214 7.01401 13.9198C7.01401 15.0179 7.67905 16 9.71293 16Z"
                            fill="white" />
                          <path
                            d="M14.5771 7.78735C16.2397 7.78735 17.6703 6.30256 17.6703 4.36926C17.6703 2.45916 16.232 1.04398 14.5771 1.04398C12.9222 1.04398 11.4838 2.49009 11.4838 4.38473C11.4838 6.30256 12.9144 7.78735 14.5771 7.78735ZM9.71294 14.9483H19.4335C20.6477 14.9483 21.0807 14.6003 21.0807 13.9198C21.0807 11.9246 18.5829 9.17156 14.5693 9.17156C10.5636 9.17156 8.06577 11.9246 8.06577 13.9198C8.06577 14.6003 8.49879 14.9483 9.71294 14.9483Z"
                            fill="black" fill-opacity="0.85" />
                        </g>
                        <defs>
                          <clipPath id="clip0_508_50">
                            <rect width="22.1325" height="16" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <p class="mb-0 d-inline-block align-middle body-2-1">{{guest.data}}x
                      Guest</p>
                    <div class="position-absolute" style="top:20px;right: 16px;">
                      <svg class="delay" :class="guest.show_detail ? 'transform-180' : ''" width="10" height="11"
                        viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_366_21)">
                          <path
                            d="M10 0.766817C10 0.301699 9.64177 0.012572 9.09491 0.012572L0.898807 0.00628662C0.35198 0.00628662 0 0.295413 0 0.760531C0 1.01195 0.113137 1.21936 0.238844 1.48334L4.16091 9.56003C4.4249 10.0943 4.66374 10.264 4.99687 10.264C5.32999 10.264 5.5751 10.0943 5.83909 9.56003L9.75489 1.48334C9.88688 1.22565 10 1.01823 10 0.766817Z"
                            fill="black" fill-opacity="0.85" />
                        </g>
                        <defs>
                          <clipPath id="clip0_366_21">
                            <rect width="10" height="10.264" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                  </button>
                  <b-popover 
                    :show.sync="guest.show_detail" 
                    placement="bottom" 
                    target="guest-filter"  
                    container="filter-container">
                    <div class="py-3" style="width: 250px;">
                      <div class="row no-gutters align-items-center">
                        <div class="col-5">
                          <p class="mb-0 body-2-4">Guest</p>
                        </div>
                        <div class="col-7">
                          <div class="d-table ml-auto no-ws">
                            <div class="d-inline-block align-middle">
                              <svg @click="guestChangeQty('min')" class="lh-1 cursor-pointer" width="20" height="20"
                                viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M9.99507 19.9901C15.463 19.9901 19.9901 15.4532 19.9901 9.99507C19.9901 4.52719 15.4532 0 9.98528 0C4.52718 0 0 4.52719 0 9.99507C0 15.4532 4.53699 19.9901 9.99507 19.9901ZM9.99507 18.3244C5.36991 18.3244 1.67565 14.6203 1.67565 9.99507C1.67565 5.36991 5.36011 1.66585 9.98528 1.66585C14.6105 1.66585 18.3244 5.36991 18.3244 9.99507C18.3244 14.6203 14.6203 18.3244 9.99507 18.3244Z"
                                  class="fill-primary" />
                                <path
                                  d="M6.14405 10.828H13.8364C14.3851 10.828 14.7574 10.5341 14.7574 10.0147C14.7574 9.48558 14.4047 9.18179 13.8364 9.18179H6.14405C5.5757 9.18179 5.21313 9.48558 5.21313 10.0147C5.21313 10.5341 5.5953 10.828 6.14405 10.828Z"
                                  class="fill-primary" />
                              </svg>
                            </div>
                            <div class="d-inline-block align-middle mx-4">
                              <p class="mb-0 font-lato text-16">{{ guest.data }}</p>
                            </div>
                            <div class="d-inline-block align-middle">
                              <svg @click="guestChangeQty('plus')" class="lh-1 cursor-pointer" width="20" height="20"
                                viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M9.99507 19.9901C15.463 19.9901 19.9901 15.4532 19.9901 9.99507C19.9901 4.52718 15.4532 0 9.98528 0C4.52718 0 0 4.52718 0 9.99507C0 15.4532 4.53699 19.9901 9.99507 19.9901ZM9.99507 18.3244C5.36991 18.3244 1.67565 14.6203 1.67565 9.99507C1.67565 5.36991 5.36011 1.66585 9.98528 1.66585C14.6105 1.66585 18.3244 5.36991 18.3244 9.99507C18.3244 14.6203 14.6203 18.3244 9.99507 18.3244Z"
                                  class="fill-primary" />
                                <path
                                  d="M5.4483 9.99507C5.4483 10.4752 5.78147 10.7986 6.28123 10.7986H9.16214V13.6894C9.16214 14.1793 9.49536 14.5223 9.9755 14.5223C10.4654 14.5223 10.8084 14.1891 10.8084 13.6894V10.7986H13.6991C14.1891 10.7986 14.5321 10.4752 14.5321 9.99507C14.5321 9.50514 14.1891 9.16214 13.6991 9.16214H10.8084V6.28123C10.8084 5.78147 10.4654 5.43851 9.9755 5.43851C9.49536 5.43851 9.16214 5.78147 9.16214 6.28123V9.16214H6.28123C5.78147 9.16214 5.4483 9.50514 5.4483 9.99507Z"
                                  class="fill-primary" />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-popover>
                </div>

                <!-- DATE -->
                <div class="col-xl-4 col-sm-6 col-12">
                  <div class="w-100 calendar-concierge lh-1">
                    <date-range-picker 
                      class="w-100" 
                      v-model="service_date.data" 
                      auto-apply 
                      :ranges="false"
                      opens="center" 
                      :min-date="service_date.min_date" 
                      :max-date="service_date.max_date"
                      :single-date-picker="true"
                      @toggle="dateToggleDetail">
                      <template v-slot:input="picker">
                        <div class="w-100 border-form radius-6 no-ws px-3 py-16px position-relative">
                          <div class="d-inline-block align-middle mr-2">
                            <svg class="lh-1" width="18" height="16" viewBox="0 0 18 16" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="M2.72599 16H14.5849C16.3993 16 17.3022 15.0971 17.3022 13.3087V2.70862C17.3022 0.92024 16.3993 0.0173645 14.5849 0.0173645H2.72599C0.911556 0.0173645 0 0.911558 0 2.70862V13.3087C0 15.1058 0.911556 16 2.72599 16ZM2.59577 14.6022C1.82311 14.6022 1.39772 14.1943 1.39772 13.3868V5.20021C1.39772 4.40151 1.82311 3.9848 2.59577 3.9848H14.6977C15.4704 3.9848 15.9045 4.40151 15.9045 5.20021V13.3868C15.9045 14.1943 15.4704 14.6022 14.6977 14.6022H2.59577ZM6.96255 7.10145H7.47472C7.77861 7.10145 7.8741 7.01464 7.8741 6.71078V6.19858C7.8741 5.89473 7.77861 5.79923 7.47472 5.79923H6.96255C6.65869 5.79923 6.55452 5.89473 6.55452 6.19858V6.71078C6.55452 7.01464 6.65869 7.10145 6.96255 7.10145ZM9.84483 7.10145H10.357C10.6608 7.10145 10.765 7.01464 10.765 6.71078V6.19858C10.765 5.89473 10.6608 5.79923 10.357 5.79923H9.84483C9.54094 5.79923 9.43678 5.89473 9.43678 6.19858V6.71078C9.43678 7.01464 9.54094 7.10145 9.84483 7.10145ZM12.7271 7.10145H13.2393C13.5431 7.10145 13.6473 7.01464 13.6473 6.71078V6.19858C13.6473 5.89473 13.5431 5.79923 13.2393 5.79923H12.7271C12.4232 5.79923 12.3277 5.89473 12.3277 6.19858V6.71078C12.3277 7.01464 12.4232 7.10145 12.7271 7.10145ZM4.08029 9.94032H4.58382C4.89636 9.94032 4.99185 9.85349 4.99185 9.54961V9.03741C4.99185 8.7336 4.89636 8.64677 4.58382 8.64677H4.08029C3.76776 8.64677 3.67227 8.7336 3.67227 9.03741V9.54961C3.67227 9.85349 3.76776 9.94032 4.08029 9.94032ZM6.96255 9.94032H7.47472C7.77861 9.94032 7.8741 9.85349 7.8741 9.54961V9.03741C7.8741 8.7336 7.77861 8.64677 7.47472 8.64677H6.96255C6.65869 8.64677 6.55452 8.7336 6.55452 9.03741V9.54961C6.55452 9.85349 6.65869 9.94032 6.96255 9.94032ZM9.84483 9.94032H10.357C10.6608 9.94032 10.765 9.85349 10.765 9.54961V9.03741C10.765 8.7336 10.6608 8.64677 10.357 8.64677H9.84483C9.54094 8.64677 9.43678 8.7336 9.43678 9.03741V9.54961C9.43678 9.85349 9.54094 9.94032 9.84483 9.94032ZM12.7271 9.94032H13.2393C13.5431 9.94032 13.6473 9.85349 13.6473 9.54961V9.03741C13.6473 8.7336 13.5431 8.64677 13.2393 8.64677H12.7271C12.4232 8.64677 12.3277 8.7336 12.3277 9.03741V9.54961C12.3277 9.85349 12.4232 9.94032 12.7271 9.94032ZM4.08029 12.7878H4.58382C4.89636 12.7878 4.99185 12.6923 4.99185 12.3885V11.8762C4.99185 11.5724 4.89636 11.4856 4.58382 11.4856H4.08029C3.76776 11.4856 3.67227 11.5724 3.67227 11.8762V12.3885C3.67227 12.6923 3.76776 12.7878 4.08029 12.7878ZM6.96255 12.7878H7.47472C7.77861 12.7878 7.8741 12.6923 7.8741 12.3885V11.8762C7.8741 11.5724 7.77861 11.4856 7.47472 11.4856H6.96255C6.65869 11.4856 6.55452 11.5724 6.55452 11.8762V12.3885C6.55452 12.6923 6.65869 12.7878 6.96255 12.7878ZM9.84483 12.7878H10.357C10.6608 12.7878 10.765 12.6923 10.765 12.3885V11.8762C10.765 11.5724 10.6608 11.4856 10.357 11.4856H9.84483C9.54094 11.4856 9.43678 11.5724 9.43678 11.8762V12.3885C9.43678 12.6923 9.54094 12.7878 9.84483 12.7878Z"
                                fill="black" fill-opacity="0.85" />
                            </svg>
                          </div>
                          <p class="mb-0 d-inline-block align-middle body-2-1">
                            {{ formatDateFilter(service_date.data.startDate) }}</p>
                          <div class="position-absolute" style="top:20px;right: 16px;">
                            <svg class="delay" :class="service_date.show_detail ? 'transform-180' : ''" width="10"
                              height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <g clip-path="url(#clip0_366_21)">
                                <path
                                  d="M10 0.766817C10 0.301699 9.64177 0.012572 9.09491 0.012572L0.898807 0.00628662C0.35198 0.00628662 0 0.295413 0 0.760531C0 1.01195 0.113137 1.21936 0.238844 1.48334L4.16091 9.56003C4.4249 10.0943 4.66374 10.264 4.99687 10.264C5.32999 10.264 5.5751 10.0943 5.83909 9.56003L9.75489 1.48334C9.88688 1.22565 10 1.01823 10 0.766817Z"
                                  fill="black" fill-opacity="0.85" />
                              </g>
                              <defs>
                                <clipPath id="clip0_366_21">
                                  <rect width="10" height="10.264" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                        </div>
                      </template>
                      <template #date="calendar_date">
                        <div class="calendar-concierge-custom-date">
                          <p class="font-lato text-12 lh-1 mb-0">{{formatDateNumber(calendar_date.date)}}</p>
                        </div>
                      </template>
                    </date-range-picker>
                  </div>
                </div>

                <!-- BUTTON -->
                <div class="col-xl-4 col-lg-12 mt-3 mt-xl-0">
                  <state-button :variant="result_check_avb != 'avb'? 'primary' : 'primary-outline'" size="lg" block
                    :click="checkAvb">Check Availability
                  </state-button>
                </div>
              </div>
              
              <!-- RESULT -->
              <div class="w-100 height-animated" id="time" :class="{'active':result_check_avb != ''}"> 
                <template v-if="result_check_avb == 'avb' && current_guest_date == lock_guest_date">
                  
                  <!-- SERVICE TIME -->
                  <div class="w-100 mb-3">
                    <p class="mb-2 body-1-4">Select service time</p>
                    <template v-if="data.use_schedule">
                      <template v-for="time in service_time.list">
                        <div 
                          class="spa-select mb-3 d-inline-block align-middle position-relative mr-3 body-2-1"
                          :class="{
                            'active': time.id == service_time.data.id,
                            'disabled': time.realtime_avb < guest.data,
                            'available': !isSpaModule && time.realtime_avb >= guest.data
                          }"
                          @click="timeSelect(time)">
                          <span v-if="!isSpaModule && time.realtime_avb >= guest.data" class="body-3 text-10 text-center mb-0 position-absolute text-orange avb-item" style="left:0px;right:0px;top:2px">{{ time.realtime_avb }} AVAILABLE</span>
                          {{ $customFormatDateTime(time.schedule_start,'HH:mm:ss', 'hh:mm A') }}
                          <span v-if="time.realtime_avb < guest.data" class="body-3 text-10 text-center mb-0 position-absolute text-danger" style="left:0px;right:0px;bottom:2px">Full Booked</span>
                        </div>
                      </template>
                    </template>
                    <div class="w-100" v-else>
                      <v-timepicker 
                        v-model="service_time.manual_data"
                        :hour-range="service_time.manual_data_range.hour" 
                        :minute-range="service_time.manual_data_range.minute" 
                        @input="onInputManualTime()"
                        hide-disabled-hours
                        hide-disabled-minutes
                        hide-clear-button
                        close-on-complete 
                        format="HH:mm" 
                        :minute-interval="10"
                        hour-label="Hour" 
                        minute-label="Minute"
                        class="time-picker-manual"
                        @close="timeSelectManual()" />
                        <p v-if="!isSpaModule" class="body-2-4 text-green mb-0 mt-2">{{ result_filter.realtime_avb }} AVAILABLE
                        </p>
                    </div>
                  </div>
  
                  <!-- PLACE -->
                  <div v-if="general_data.use_place_choices" class="w-100 mb-3 height-animated" id="place"
                    :class="{'active': (data.use_schedule && service_time.data.id) || (!data.use_schedule && service_time.manual_data.HH != '' && service_time.manual_data.mm != '') }">
                    <p class="mb-2 body-1-4">Choose a place for the spa</p>
                    <div class="spa-select mb-3 d-inline-block align-middle mr-3 body-2-1"
                      :class="plc == place.data?'active':''" v-for="plc in place.list" @click="placeSelect(plc)">
                      {{ plc }}
                    </div>
                  </div>
  
                  <!-- GENDER -->
                  <div v-if="general_data.use_gender_therapist_choices" class="w-100 mb-4 height-animated" id="specialist"
                    :class="{'active': (general_data.use_place_choices && place.data != '') || (!general_data.use_place_choices && data.use_schedule && service_time.data.id) || (!general_data.use_place_choices && !data.use_schedule && service_time.manual_data.HH != '' && service_time.manual_data.mm != '')}">
                    <div class="w-100 border-form radius-6 p-3">
                      <div class="row align-items-center">
                        <div @click="genderToggleDetail()" class="col-10 lh-1">
                          <p class="body-2-1 mb-0">Preferred gender of therapist?</p>
                        </div>
                        <div @click="genderToggleDetail()" class="col-2 lh-1 text-right">
                          <svg class="lh-1" v-if="!specialist.show_detail" width="22" height="18" viewBox="0 0 22 18"
                            fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M2.9296 17.1764H19.0704C21.0297 17.1764 22 16.2155 22 14.2935V2.89228C22 0.970314 21.0297 0 19.0704 0H2.9296C0.979645 0 0 0.970314 0 2.89228V14.2935C0 16.2155 0.979645 17.1764 2.9296 17.1764ZM2.94826 15.6743C2.01527 15.6743 1.50212 15.1798 1.50212 14.2095V2.97625C1.50212 2.00594 2.01527 1.50212 2.94826 1.50212H19.0518C19.9754 1.50212 20.4979 2.00594 20.4979 2.97625V14.2095C20.4979 15.1798 19.9754 15.6743 19.0518 15.6743H2.94826Z"
                              fill="black" fill-opacity="0.85" />
                          </svg>
                          <svg class="lh-1" v-else width="22" height="18" viewBox="0 0 22 18" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_385_34)">
                              <path
                                d="M2.9296 17.1764H19.0704C21.0297 17.1764 22 16.2155 22 14.2935V2.89228C22 0.970314 21.0297 0 19.0704 0H2.9296C0.979645 0 0 0.970314 0 2.89228V14.2935C0 16.2155 0.979645 17.1764 2.9296 17.1764Z"
                                class="fill-primary" />
                              <path
                                d="M9.96436 13.1552C9.63786 13.1552 9.38596 13.0246 9.13405 12.698L6.80153 9.82439C6.65225 9.63786 6.57761 9.43261 6.57761 9.21796C6.57761 8.79815 6.89483 8.45294 7.32401 8.45294C7.58524 8.45294 7.79984 8.53693 8.02373 8.84481L9.9271 11.2892L13.911 4.88888C14.0789 4.60899 14.3215 4.45971 14.5734 4.45971C14.9839 4.45971 15.3664 4.73961 15.3664 5.17812C15.3664 5.38338 15.2451 5.59796 15.1332 5.79389L10.7388 12.698C10.5522 13.0059 10.2816 13.1552 9.96436 13.1552Z"
                                fill="white" />
                            </g>
                            <defs>
                              <clipPath id="clip0_385_34">
                                <rect width="22" height="17.1764" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                        <div class="col-12 no-ws height-animated" :class="{'active': specialist.show_detail}">
                          <div class="border-b-form-dashed-2 w-100 d-block my-3"></div>
                          <div class="w-100 no-ws">
                            <div class="spa-select d-inline-block align-middle mr-3 body-2-1"
                              v-for="gender_therapist in specialist.list"
                              :class="gender_therapist == specialist.data ? 'active' : ''"
                              @click="genderSelect(gender_therapist)">
                              {{ gender_therapist }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
  
                  <block :heigt="120" />
                  
                  <!-- BUTTON & PRICE -->
                  <div class="w-100 mt-3 pt-3 border-t-form">
                    <div class="row align-items-center">
                      <div class="col-xl-8 col-sm-7 col-6">
                        <p class="body-3-3-1 mb-1">Total price</p>
                        <div class="w-100 no-ws mb-1">
                          <p class="d-inline-block align-bottom mb-0 text-24 text-orange font-lato lh-1">
                            <template v-if="total_price.display.final > 0">
                              {{ $formatCurrency(total_price.display.final) }}
                            </template>
                            <template v-else>
                              -
                            </template>
                          </p>
                          <p class="d-inline-block align-bottom mb-0 body-2 text-line-through ml-2" v-if="total_price.display.final > 0 && total_price.display.promotion_pct > 0">{{ $formatCurrency(total_price.display.base) }}</p>
                        </div>
                        <!-- <p class="body-3-3-1 mb-0">Includes taxes and services</p> -->
                      </div>
                      <div class="col-xl-4 col-sm-5 col-6">
                        <state-button :disabled="!button_book_valid" variant="primary" size="lg" block
                          :click="addToCart">Add to cart</state-button>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="w-100 text-center p-5">
                    <p class="mb-0 heading-5-2 text-danger">Oops!</p>
                    <template v-if="result_check_avb == 'avb' && current_guest_date != lock_guest_date">
                      <p class="mb-0 body-2-2">It looks like you made a change to the number of guests or the date. Please click the <b>"Check Availability"</b> button to get data that matches your filter.</p>
                    </template>
                    <template v-else>
                      <p class="mb-0 body-2-2" v-if="result_check_avb == 'no-avb'">Sorry! There are no schedules available for <b>{{ $formatDate(service_date.data.startDate) }}</b>. Please change the date.</p>
                      <template v-else>
                        <p class="mb-0 body-2-2">Sorry! Something went wrong</p>
                        <p class="mb-0 body-3-3-1">Detail Error : {{ result_check_avb }}</p>
                      </template>
                    </template>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import DateRangePicker from 'vue2-daterange-picker';
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
  import ProductSliderDetail from './ProductSliderDetail';
  import moment from 'moment';
  import {
    get
  } from '@/services/index.js';
  import {
    mapGetters,
    mapMutations
  } from 'vuex';

  export default {
    props:{
      data:{
        type: Object,
        default: () => {}
      },
      general_data:{
        type: Object,
        default: () => {}
      },
      window_width:{
        type: Number,
        default: 0
      },
      page_source:{
        type: String,
        default: 'general'
      }
    },
    components: {
      DateRangePicker,
      ProductSliderDetail
    },
    data() {
      return {
        slider_key: 0,
        guest: {
          show_detail: false,
          data: 1
        },
        service_date: {
          show_detail: false,
          data: {
            startDate: moment().toDate(),
            endDate: moment().toDate(),
          },
          min_date: moment().toDate(),
          max_date: null
        },
        result_check_avb: '',
        lock_guest_date: '',
        result_filter:{},
        service_time: {
          list: [],
          data: {},
          manual_data: {
            HH: '--',
            mm: '--'
          },
          manual_data_range: {
            hour: [[0,23]],
            minute: [[0,59]],
            minute_start: "00",
            minute_end: "60",
          }
        },
        place: {
          list: [],
          data: ''
        },
        specialist: {
          show_detail: false,
          list: ['Male', 'Female'],
          data: ''
        },
        total_price: {
          final: 0,
          base: 0,
          promotion_amount: 0,
          promotion_pct: 0,
          taxes: 0,
          services: 0,
          source: {},
          display:{
            base: 0,
            final: 0,
            promotion_pct: 0
          }
        }
      }
    },
    computed: {
      ...mapGetters([
        'getMerchant',
        'getActivityTrxPromoCode',
        'getActivityTrxMasterAvb',
        'getActivityTrxProducts',
        'getBeFilter'
      ]),
      page_module(){
        if(this.page_source == 'general'){
          if(this.$route.meta.sub_module) return this.$route.meta.sub_module
          return ''
        }else{
          if(this.general_data.pos_type == 'SPA') return 'concierge-spa'
          return 'hotel-activity'
        }
      },
      isSpaModule(){
        if(this.$isNotEmptyV2(this.general_data.pos_type)) return this.general_data.pos_type == 'SPA'
        return false
      },  
      api_module(){
        if(this.page_module == 'hotel-activity') return 'CORE_HOTEL'
        return 'CONCIERGE'
      },
      pos_code() {
        if(this.page_module == 'hotel-activity') return this.$route.params.pos_code
        return 'spa'
      },
      guest_included() {
        if (this.data.guest_include == 1) return `per person`
        return `per ${this.data.guest_include} people`
      },
      tax_service() {
        let ts = this.data.tax_services
        if (ts) {
          if (ts.calculation_type == 'INCLUDE') return 'Includes taxes and services'
          return 'Excludes taxes and service'
        } else {
          return ''
        }
      },
      button_book_valid() {
        let is_valid = true
        let use_schedule = this.data.use_schedule
        let use_place = this.general_data.use_place_choices
        let use_gender = this.general_data.use_gender_therapist_choices
        let time_form_sch = this.service_time.data.id
        let time_form_manual = this.service_time.manual_data.HH == '--' || this.service_time.manual_data.mm == '--'
        let place_form = this.place.data
        let gender_select = this.specialist.show_detail
        let gender_form = this.specialist.data
        let gender_valid = !gender_select || (gender_select && gender_form != '')

        if(use_schedule && !time_form_sch) is_valid = false
        else if(!use_schedule && time_form_manual) is_valid = false
        else if(use_place && place_form == '') is_valid = false
        else if(use_gender && !gender_valid) is_valid = false

        return is_valid
      },
      current_guest_date(){
        return `${this.guest.data} - ${this.$formatDate(this.service_date.data.startDate)}`
      },
      duration(){
        if(!this.$isNotEmpty(this.data.duration_text)) return ''
        else{
          let text = this.data.duration_text
          if(this.data.duration_type == 'HOUR' || this.data.duration_type == 'MINUTE'){
            let unit = this.data.duration_type == 'HOUR' ? 'Hour(s)' : 'Minute(s)'
            text += ` ${unit}`
          }
          return text
        }
      }
    },
    watch:{
      result_check_avb(){
        if(this.result_check_avb == 'avb'){
          this.lock_guest_date = `${this.guest.data} - ${this.$formatDate(this.service_date.data.startDate)}`
        }else{
          this.lock_guest_date = ''
        }
      }
    },
    mounted(){
      this.loadFirstData()
    },
    methods: {
      // GENERAL
      ...mapMutations(['setTrxActivityProduct']),
      formatDateNumber(value) {
        return moment(value).format("D")
      },
      formatDateFilter(value) {
        return moment(value).format("D MMM YYYY")
      },
      close() {
        this.$emit('close')
      },
      filterFormGoTop(id) {
        setTimeout(() => {
          this.$smoothScroll(id)
        }, 100)
      },

      loadFirstData(){
        setTimeout(() => {
          this.slider_key++
        }, 100)

        const isAdditionalServiceCart = this.getMerchant.additional_appearance === 'CART' && this.page_source == 'additional_service'
        if(isAdditionalServiceCart){
          this.service_date.min_date = moment(this.getBeFilter.date.check_in).format("YYYY-MM-DD")
          this.service_date.max_date = moment(this.getBeFilter.date.check_out).format("YYYY-MM-DD")
          this.service_date.data = {
            startDate: this.service_date.min_date,
            endDate: this.service_date.min_date,
          }
        }else{
          if(this.data.use_schedule){
            this.checkTodayAvbIfSchedule()
          }
        }
        
      },
      checkTodayAvbIfSchedule(){
        let copy_schedule = this.$deepCopy(this.data.schedule) 
        let avb_sch = [] //available schedule
        let today = moment()
        avb_sch = copy_schedule.filter(x=>{
          let sch_today = moment(x.schedule_start,"HH:mm:ss").toDate()
          if(x.cut_off > 0){
            sch_today = moment(sch_today).subtract(x.cut_off,'hours')
          }
          if(moment(today).isBefore(sch_today)){
            return x
          }else{
            return false
          }
        })
        if(avb_sch.length == 0){
          this.service_date.data = {
            startDate: moment().add(1,'d').toDate(),
            endDate: moment().add(1,'d').toDate(),
          }
          this.service_date.min_date = moment().add(1,'d').toDate()
        }else{
        }
      },


      // GUEST FUNCTION
      guestToggleDetail() {
        this.guest.show_detail = !this.guest.show_detail
      },
      guestChangeQty(action) {
        if (!(action == 'min' && this.guest.data == 1)) {
          if (action == 'min') this.guest.data--
          else this.guest.data++
        }
      },
      setTotalPrice(data=null){
        if(data == null){
          this.total_price = {
            final: 0,
            base: 0,
            promotion_amount: 0,
            promotion_pct: 0,
            taxes: 0,
            services: 0,
            source: {},
            display:{
              base: 0,
              final: 0,
              promotion_pct: 0
            }
          }
        }else{
          let calculatePromotion = (base_price,promotion_pct) => {
            let promotion_amount = base_price*(promotion_pct/100)
            let final = base_price-promotion_amount
            return final
          }
          
          this.total_price = {
            final: data.price_sell_final_with_tax_service*Number(this.guest.data),
            base: data.price_sell*Number(this.guest.data),
            promotion_amount: data.promotion_amount*Number(this.guest.data),
            promotion_pct: data.promotion_pct,
            taxes: data.tax_amount*Number(this.guest.data),
            services: data.service_amount*Number(this.guest.data),
            source: data,
            display:{
              base: data.price_sell*Number(this.guest.data),
              final: Math.round(data.promotion_pct) == 0 ? data.price_sell*Number(this.guest.data) : calculatePromotion(data.price_sell,Math.round(data.promotion_pct))*Number(this.guest.data),
              promotion_pct: Math.round(data.promotion_pct)
            }
          }
        }
      },

      // DATE
      dateToggleDetail(show) {
        this.service_date.show_detail = show
        if (show){
          this.guest.show_detail = false
          this.filterFormGoTop('time')
        }
      },

      // TIME
      timeSelect(time) {
        if(time.realtime_avb >= this.guest.data){
          this.service_time.data = time
          this.setTotalPrice(time.price)
          if(this.general_data.use_place_choices){
            this.filterFormGoTop('place')
          }else if(this.general_data.use_gender_therapist_choices){
            this.filterFormGoTop('specialist')
          }
        }
      },
      timeSelectManual(){
        let form_valid = this.service_time.manual_data.HH != '' && this.service_time.manual_data.mm != ''
        if(form_valid){
          if(this.general_data.use_place_choices){
            this.filterFormGoTop('place')
          }else if(this.general_data.use_gender_therapist_choices){
            this.filterFormGoTop('specialist')
          }
        }
      },

      // PLACE
      placeSelect(place) {
        this.place.data = place
        if(this.general_data.use_gender_therapist_choices){
          this.filterFormGoTop('specialist')
        }
      },

      // GENDER
      genderToggleDetail(show) {
        this.specialist.show_detail = !this.specialist.show_detail
        this.filterFormGoTop('specialist')
      },
      genderSelect(gender) {
        this.specialist.data = gender
      },

      // ADVANCE
      checkAvb() {
        return new Promise((success, fail) => {
          this.result_check_avb = ''
          this.service_time = {
            list: [],
            data: {},
            manual_data: {
              HH: '--',
              mm: '--'
            },
            manual_data_range: {
              hour: [[0,23]],
              minute: [[0,59]],
              minute_start: "00",
              minute_end: "60",
            }
          }
          this.place = {
            list: [],
            data: ''
          },
          this.specialist = {
            show_detail: false,
            list: ['Male', 'Female'],
            data: ''
          }

          let params = {
            merchant_id: this.getMerchant.id,
            qty: this.guest.data,
            date: moment(this.service_date.data.startDate).format("YYYY-MM-DD")
          }
          if(this.getActivityTrxPromoCode != ''){
            params.promo_code = this.getActivityTrxPromoCode
          }

          let api_url = this.page_module == 'concierge-spa' ? `spa/product/${this.data.id}` : `merchant-pos/${this.general_data.id}/product/${this.data.id}`
          
          get(this.api_module, api_url, params).then(response => {
            let res = response.data
            if (res.success) {
              this.result_filter = res.data
              this.setTotalPrice(res.data.price)

              // SCHEDULE
              if(this.data.use_schedule){
                let is_time_avb = res.data.schedule.some(x=>x.availability >= this.guest.data)
                if(is_time_avb){
                  
                  let today = moment().toDate()
                  let copy_schedule = this.$deepCopy(res.data.schedule)

                  // check for cutoff
                  this.service_time.list = copy_schedule.filter(x=>{
                    let sche_hour = moment(x.schedule_start, "HH:mm:ss").format("HH")
                    let sche_minute = moment(x.schedule_start, "HH:mm:ss").format("mm")
                    
                    
                    let sch_today = moment(this.service_date.data.startDate).set({ hour: sche_hour, minute: sche_minute });
                    if(x.cut_off > 0){
                      sch_today = moment(sch_today).subtract(x.cut_off,'hours')
                    }
                    
                    if(moment(today).isBefore(sch_today)){
                      return x
                    }else{
                      return false
                    }
                  })

                  // check for availbility
                  this.setupServiceTimeList()
                  
                  this.result_check_avb = this.service_time.list.length == 0 ? 'no-avb' : 'avb'
                  // if(is_service_date_today){
                  // }else{
                  //   this.service_time.list = res.data.schedule
                  //   this.setupServiceTimeList()
                  //   this.result_check_avb = 'avb'
                  // }

                  let is_time_have_dynamic_price = res.data.schedule.some(x=>x.price_by_pax.length > 0)
                  if(is_time_have_dynamic_price) {
                    this.setTotalPrice()
                  }
                }else{
                  this.result_check_avb = 'no-avb'
                }
              }
              // STANDART
              else{
                if(this.$isNotEmpty(res.data.open_order_time) && this.$isNotEmpty(res.data.open_order_time)) this.setupServiceTimeNonSchedule(res.data)
                
                this.result_filter.realtime_avb = res.data.availability
                let vuex_master_avb = this.getActivityTrxMasterAvb
                let service_date = moment(this.service_date.data.startDate).format("YYYY-MM-DD")
                if(this.result_filter.use_master_availability){

                  let checkAvb = (master_avb) => {
                    let total_per_combination = master_avb.map(avb=> Math.floor(Number(avb.realtime_avb)/Number(avb.qty)))
                    let total_combination = Math.min(...total_per_combination)
                    return total_combination
                  }               
                  this.result_filter.master_availability_reference_data = this.result_filter.master_availability_reference_data.map(mvb => {
                    
                    mvb.realtime_avb = mvb.availability
                    
                    let record_mvb = vuex_master_avb.findIndex(v_mvb=>v_mvb.reference_id == mvb.reference_id)
                    if(record_mvb != -1){
                      
                      let record_mvb_date = vuex_master_avb[record_mvb].dates.findIndex(d_mvb=>d_mvb.date == service_date)
                      if(record_mvb_date != -1) {
                        
                        let record_product_vuex = this.getActivityTrxProducts.findIndex(prd=>prd.original_data.id == this.data.id)
                        if(record_product_vuex != -1){
                          
                          let record_master_avb_in_product = this.getActivityTrxProducts[record_product_vuex].original_data.master_availability_reference_data.findIndex(x=>x.reference_id == mvb.reference_id)
                          if(record_master_avb_in_product != -1){
                            
                            let master_avb_in_product = Number(this.getActivityTrxProducts[record_product_vuex].original_data.master_availability_reference_data[record_master_avb_in_product].qty)
                            let taken_avb_from_master = (master_avb_in_product*this.getActivityTrxProducts[record_product_vuex].qty)
                            mvb.realtime_avb = vuex_master_avb[record_mvb].dates[record_mvb_date].availability + taken_avb_from_master
                          }
                          
                        }else{
                          mvb.realtime_avb = vuex_master_avb[record_mvb].dates[record_mvb_date].availability
                        }
                      }
                    }
                    return mvb
                  })
                  this.result_filter.realtime_avb = checkAvb(this.result_filter.master_availability_reference_data)
                }else{
                  let master_avb = vuex_master_avb.find(x=>x.reference_id == this.result_filter.ga_concierge_id)
                  if(master_avb){
                    let date_avb = master_avb.dates.find(x=>x.date == service_date)
                    if(date_avb){
                      this.result_filter.realtime_avb = date_avb.availability
                    }
                  }
                }

                this.result_check_avb = this.result_filter.realtime_avb >= this.guest.data ? 'avb' : 'no-avb'
                
              }
              
              if(this.general_data.use_place_choices){
                this.place.list = this.general_data.place_choices
              }
            } else {
              this.result_check_avb = res.message
            }
            this.filterFormGoTop('time')
            success()
          })
        })
      },
      setupServiceTimeList(){
        let vuex_master_avb = this.getActivityTrxMasterAvb
        
        let checkAvb = (master_avb) => {
          let total_per_combination = master_avb.map(avb=> Math.floor(Number(avb.realtime_avb)/Number(avb.qty)))
          let total_combination = Math.min(...total_per_combination)
          return total_combination
        }
        
        let service_date = moment(this.service_date.data.startDate).format("YYYY-MM-DD")
        
        this.service_time.list = this.service_time.list.map(sch=>{
          sch.realtime_avb = sch.availability
          if(sch.use_master_availability){
            sch.master_availability_reference_data = sch.master_availability_reference_data.map(mvb => {
              
              mvb.realtime_avb = mvb.availability
              
              let record_mvb = vuex_master_avb.findIndex(v_mvb=>v_mvb.reference_id == mvb.reference_id)
              if(record_mvb != -1){
                
                let record_mvb_date = vuex_master_avb[record_mvb].dates.findIndex(d_mvb=>d_mvb.date == service_date)
                if(record_mvb_date != -1) {
                  
                  let record_product_vuex = this.getActivityTrxProducts.findIndex(prd=>prd.original_data.id == this.data.id)
                  if(record_product_vuex != -1){
                    
                    let record_master_avb_in_product = this.getActivityTrxProducts[record_product_vuex].service_time.master_availability_reference_data.findIndex(x=>x.reference_id == mvb.reference_id)
                    if(record_master_avb_in_product != -1){
                      
                      let master_avb_in_product = Number(this.getActivityTrxProducts[record_product_vuex].service_time.master_availability_reference_data[record_master_avb_in_product].qty)
                      let taken_avb_from_master = (master_avb_in_product*this.getActivityTrxProducts[record_product_vuex].qty)
                      mvb.realtime_avb = vuex_master_avb[record_mvb].dates[record_mvb_date].availability + taken_avb_from_master
                    }
                    
                  }else{
                    mvb.realtime_avb = vuex_master_avb[record_mvb].dates[record_mvb_date].availability
                  }
                }
              }
              return mvb
            })
            sch.realtime_avb = checkAvb(sch.master_availability_reference_data)
          }else{
            let master_avb = vuex_master_avb.find(x=>x.reference_id == sch.id)
            if(master_avb){
              let date_avb = master_avb.dates.find(x=>x.date == service_date)
              if(date_avb){
                sch.realtime_avb = date_avb.availability
              }
            }
          }
          return sch
        })
      },
      setupServiceTimeNonSchedule(data){
        let time_start = moment(data.open_order_time,'HH:mm:ss')
        let hour_start = time_start.format("H")
        let minute_start = time_start.format("mm")
        let time_end = moment(data.close_order_time,'HH:mm:ss')
        let hour_end = time_end.format("H")
        let minute_end = time_end.format("mm")
        
        if(time_start.isBefore(time_end,'hour')){
          this.service_time.manual_data_range.minute_start = Number(minute_start)
          this.service_time.manual_data_range.minute_end = Number(minute_end)
          let new_hour_end = Number(hour_end)
          if(minute_end == '00'){
            new_hour_end--
          }
          this.service_time.manual_data_range.hour = [[hour_start,new_hour_end]]
        }
      },
      onInputManualTime(){
        let {minute_start, minute_end} = this.service_time.manual_data_range
        let minute_not_standart = minute_start > 0 || minute_end > 0
        
        if(minute_not_standart){
          
          let {HH,mm} = this.service_time.manual_data;
          let is_first_hour_selected = Number(HH) == this.service_time.manual_data_range.hour[0][0]
          let is_last_hour_selected = Number(HH) == this.service_time.manual_data_range.hour[0][1]
          
          if(is_first_hour_selected && minute_start > 0){
            
            if(mm != '' && Number(mm) < minute_start){
              this.service_time.manual_data.mm = '--'
            }
            this.service_time.manual_data_range.minute = [[minute_start,60]]
            
          }else if(is_last_hour_selected && minute_end > 0){
            
            if(mm != '' && Number(mm) > minute_end){
              this.service_time.manual_data.mm = '--'
            }
            this.service_time.manual_data_range.minute = [[0,minute_end]]
            
          }else{
            this.service_time.manual_data_range.minute = [[0,60]]
          }
        }
      },
      addToCart() {
        return new Promise((success, fail) => {
          let params_to_vuex = {
            product: this.result_filter,
            qty: this.guest.data,
            date: this.service_date.data.startDate,
            time: {},
            place: this.place.data,
            gender: !this.general_data.use_gender_therapist_choices ? '' : this.specialist.data == '' ? 'Random' : this.specialist.data,
            base_price: this.total_price,
            page_module: this.page_module == 'concierge-spa' ? this.general_data.merchant_pos_id : this.general_data.id
          }

          if(this.page_source != 'general') params_to_vuex.page_module = this.page_source
          
          if(this.result_filter.use_schedule){
            params_to_vuex.time = this.service_time.data
          }else{
            params_to_vuex.time = {
              schedule_start: `${this.service_time.manual_data.HH}:${this.service_time.manual_data.mm}:00`
            }
          }
          
          setTimeout(() => { 
            this.setTrxActivityProduct(params_to_vuex)
            this.close()
            success()
          }, 500)
        })
      },
      resetFormDetail() {
        this.guest = {
          show_detail: false,
          data: 1
        },
        this.service_date = {
          show_detail: false,
          data: {
            startDate: moment().toDate(),
            endDate: moment().toDate(),
          },
          min_date: moment().toDate(),
        },
        this.result_check_avb = '',
        this.service_time = {
          list: [],
          data: {},
          manual_data: {
            HH: '',
            mm: ''
          },
          manual_data_range: {
            hour: [[0,23]],
            minute: [[0,59]],
            minute_start: "00",
            minute_end: "60",
          }
        },
        this.place = {
          list: [],
          data: ''
        },
        this.specialist = {
          show_detail: false,
          list: ['Male', 'Female'],
          data: ''
        }
      }
    }
  }

</script>
<style>
  .card-product-height {
    height: 200px;
  }

  .bottom-0 {
    bottom: 0 !important;
  }

  .spa-select {
    padding: 10px 15px;
    border: 1px solid #CCC;
    border-radius: 6px;
    cursor: pointer;
  }

  .spa-select.active {
    color: #fff;
    border-color: var(--merchant-button-color);
    background-color: var(--merchant-button-color);
  }
  .spa-select.active > .avb-item{
    color: #fff !important;
  }
  .spa-select.disabled {
    background-color: #EEE;
    color: #777;
    cursor: not-allowed;
    padding-top: 6px !important;
    padding-bottom: 14px !important;
  }
  .spa-select.available {
    padding-top: 14px !important;
    padding-bottom: 6px !important;
  }

  .height-animated {
    height: 0px;
    max-height: 0px;
    transition: max-height 0.3s;
    overflow: hidden;
  }

  .height-animated.active {
    height: auto;
    max-height: 1000px;
  }

</style>



// WEBPACK FOOTER //
// src/components/hotel/concierge/activity/ProductDetail.vue